/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import api from '../../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import Loading from '../../../components/atoms/Loading'
import {
  ChevronDown,
  ChevronUp,
  ArrowLeft,
  Menu,
  DownloadIcon
} from 'lucide-react'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import { convertDateWithTime } from '../../../helpers/constants'
import moment from 'moment'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#888',
  textTransform: 'uppercase',
  marginBottom: '0.2rem',
  letterSpacing: '0.5px'
}

const valueStyle = {
  fontSize: '1rem',
  fontWeight: '500',
  color: '#333'
}

function DetailTransferRackPage() {
  const { id } = useParams()
  const { state } = useLocation()
  const [loading, setLoading] = useState(false)
  const [expand, setExpand] = useState(true)
  const [data, setData] = useState(null)
  const [collapsedRows, setCollapsedRows] = useState([])
  const [loadingDownload, setLoadingDownload] = useState({})
  const navigate = useNavigate()

  const handleDownloadLabel = async (itemId) => {
    try {
      setLoadingDownload((prev) => ({ ...prev, [itemId]: true }))
      const res = await api.get(`transfer-rack/${id}/${itemId}`, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `label_${itemId}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        setTimeout(() => {
          toast.success('Label downloaded!')
        }, 1000)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(err)
    } finally {
      setLoadingDownload((prev) => ({ ...prev, [itemId]: false }))
    }
  }

  const getData = async () => {
    try {
      setLoading(true)
      const response = await api.get(`transfer-rack/${id}`)
      const { data: dataResponse } = response.data
      const newDataItems = dataResponse?.items?.reduce((acc, cur) => {
        if (acc.length > 0 && acc[acc.length - 1].palet_id === cur.palet_id) {
          acc[acc.length - 1].items.push({
            ...cur
          })
        } else {
          acc.push({
            ...cur,
            items: [
              {
                ...cur
              }
            ]
          })
        }
        return acc
      }, [])
      setData({
        ...dataResponse,
        dataItems: newDataItems
      })
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg)
      navigate('/transfer/transfer_antar_rak', {
        state: state
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      getData()
    }
  }, [id])

  if (loading) {
    return <Loading />
  }

  return (
    <Container fluid className="px-4 pb-4">
      <Toaster />
      <Row className="mb-3">
        <Col md={12}>
          <div className="d-flex align-items-center gap-2 mb-2">
            <Link
              to="/transfer/transfer_antar_rak"
              state={state}
              className="text-decoration-none text-secondary d-flex align-items-center"
            >
              <ArrowLeft size={16} className="me-2" />
              Transfer Pallet Antar Rak
            </Link>
            <span className="text-muted">/</span>
            <span className="text-dark fw-bold">Detail</span>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 style={headerTitleStyle}>Transfer Rack Detail</h3>
          </div>
        </Col>
      </Row>

      <Card style={cardStyle}>
        <Row className="mb-4">
          <Col md={6}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Transfer Code</span>
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: 'var(--primary-orange)'
                  }}
                >
                  {data?.code}
                </span>
                <div style={{ fontSize: '14px' }}>
                  <BadgeStatusPrLists
                    text={data?.status ? data?.status.replaceAll('_', ' ') : ''}
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col md={6} className="text-md-end">
            <div className="d-flex flex-column align-items-md-end">
              <span style={labelStyle}>Warehouse</span>
              <span style={valueStyle}>{data?.warehouse || '-'}</span>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <h5
              className="mb-3 fw-bold text-secondary"
              style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}
            >
              ITEMS
            </h5>
            <Table
              responsive
              className="mb-5 bg-white border"
              style={{ borderRadius: '8px', overflow: 'hidden' }}
            >
              <thead style={{ backgroundColor: '#f4f5f7' }}>
                <tr>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Slot Name
                  </th>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Palet
                  </th>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Area
                  </th>
                  <th
                    className="p-3 text-muted border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Destination
                  </th>
                  <th
                    className="p-3 text-muted text-end border-bottom"
                    style={{ fontWeight: '700', fontSize: '0.85rem' }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.dataItems?.map((item, index) => (
                  <React.Fragment key={index}>
                    <tr className="bg-white">
                      <td className="p-3 align-middle fw-semibold text-dark">
                        {item.slot || '-'}
                      </td>
                      <td className="p-3 align-middle">
                        {item.palet_id || '-'}
                      </td>
                      <td className="p-3 align-middle">{item.area || '-'}</td>
                      <td className="p-3 align-middle">
                        <span style={{ color: '#f89d1d' }}>
                          {item.destination || '-'}
                        </span>
                      </td>
                      <td className="p-3 align-middle text-end">
                        <Button
                          variant="secondary"
                          className="p-1 border-0"
                          style={{ backgroundColor: '#6c757d' }}
                          onClick={() =>
                            setCollapsedRows((prev) =>
                              prev.includes(index)
                                ? prev.filter((i) => i !== index)
                                : [...prev, index]
                            )
                          }
                        >
                          <Menu size={16} className="text-white" />
                        </Button>
                      </td>
                    </tr>
                    {!collapsedRows.includes(index) && (
                      <tr>
                        <td colSpan={5} className="p-0 border-0">
                          <Table
                            responsive
                            className="mb-4 mx-auto"
                            style={{
                              width: '98%',
                              backgroundColor: '#fcfcfc',
                              border: '1px solid #eee'
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: '#f4f5f7' }}>
                                <th
                                  className="p-3 text-muted"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Item Code - Name
                                </th>
                                <th
                                  className="p-3 text-muted"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Batch
                                </th>
                                <th
                                  className="p-3 text-muted"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Exp Date
                                </th>
                                <th
                                  className="p-3 text-muted"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Available
                                  <br />
                                  Qty Kemasan
                                </th>
                                <th
                                  className="p-3 text-muted"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Available Base
                                  <br />
                                  Qty UOM
                                </th>
                                <th
                                  className="p-3 text-muted"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Picked
                                  <br />
                                  Qty Kemasan
                                </th>
                                <th
                                  className="p-3 text-muted"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Picked Base
                                  <br />
                                  Qty UOM
                                </th>
                                <th
                                  className="p-3 text-muted text-end"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  Label
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.items.map((subItem, subIndex) => (
                                <tr
                                  key={subIndex}
                                  className="bg-white border-bottom"
                                >
                                  <td className="p-3 align-middle text-dark fw-semibold">
                                    {`${subItem.item_code || ''} - ${
                                      subItem.item_name || ''
                                    }`}
                                  </td>
                                  <td className="p-3 align-middle">
                                    {subItem.batch || '-'}
                                  </td>
                                  <td className="p-3 align-middle">
                                    {subItem.exp_date || '-'}
                                  </td>
                                  <td className="p-3 align-middle">
                                    {subItem.total_pack
                                      ? `${subItem.total_pack} ${
                                          subItem.uom_pack || ''
                                        }`
                                      : '-'}
                                  </td>
                                  <td className="p-3 align-middle">
                                    {subItem.total_qty
                                      ? `${subItem.total_qty} ${
                                          subItem.uom_qty || ''
                                        }`
                                      : '-'}
                                  </td>
                                  <td
                                    className="p-3 align-middle"
                                    style={{ backgroundColor: '#ced4da' }}
                                  >
                                    {subItem.picked_pack || subItem.total_pack
                                      ? `${subItem.picked_pack || subItem.total_pack} ${
                                          subItem.uom_pack || ''
                                        }`
                                      : '-'}
                                  </td>
                                  <td
                                    className="p-3 align-middle"
                                    style={{ backgroundColor: '#ced4da' }}
                                  >
                                    {subItem.picked_qty || subItem.total_qty
                                      ? `${subItem.picked_qty || subItem.total_qty} ${
                                          subItem.uom_qty || ''
                                        }`
                                      : '-'}
                                  </td>
                                  <td className="p-3 align-middle text-end">
                                    <Button
                                      variant={`${
                                        loadingDownload[subItem.id]
                                          ? 'secondary'
                                          : 'warning'
                                      }`}
                                      size="sm"
                                      className="p-1 border-0"
                                      style={{
                                        backgroundColor: loadingDownload[
                                          subItem.id
                                        ]
                                          ? '#6c757d'
                                          : '#f89d1d',
                                        cursor: 'pointer'
                                      }}
                                      onClick={() =>
                                        handleDownloadLabel(subItem.id)
                                      }
                                      disabled={loadingDownload[subItem.id]}
                                    >
                                      <DownloadIcon
                                        size={16}
                                        className="text-white"
                                      />
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>

      <Card style={cardStyle}>
        <div
          className="d-flex justify-content-between align-items-center cursor-pointer mb-3"
          onClick={() => setExpand(!expand)}
          style={{ cursor: 'pointer' }}
        >
          <h5 className="m-0 fw-bold text-dark" style={{ fontSize: '1rem' }}>
            PROGRESS DETAIL
          </h5>
          <Button variant="transparent" className="p-0 text-secondary">
            {expand ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </Button>
        </div>

        <Collapse in={expand}>
          <div id="progress-collapse" className="mt-4 ms-3 position-relative">
            <div
              className="position-absolute"
              style={{
                top: '0',
                bottom: '0',
                left: '6px',
                borderLeft: '2px solid #e9ecef',
                zIndex: 0
              }}
            />
            {data?.progress_detail?.length > 0 ? (
              data?.progress_detail.map((item, index) => (
                <div
                  key={index}
                  className="d-flex align-items-start mb-4 position-relative"
                  style={{ zIndex: 1 }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center bg-white"
                    style={{
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      border: '2px solid var(--primary-orange)',
                      marginTop: '4px',
                      marginRight: '1rem',
                      flexShrink: 0
                    }}
                  >
                    <div
                      style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        backgroundColor: 'var(--primary-orange)'
                      }}
                    />
                  </div>
                  <div className="w-100">
                    <div
                      className="text-secondary small mb-1"
                      style={{ fontSize: '0.75rem', marginTop: '2px' }}
                    >
                      {item?.created_at || '-'}
                    </div>
                    <div
                      className="fw-bold text-dark"
                      style={{ fontSize: '0.9rem' }}
                    >
                      {item?.description}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="p-3 text-muted fst-italic">Data Empty!</div>
            )}
          </div>
        </Collapse>
      </Card>

      <Card style={cardStyle}>
        <Row>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Created By</span>
              <span style={valueStyle}>
                {!data?.created_by
                  ? '-'
                  : firstLetterUpperCase(data?.created_by)}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Created At</span>
              <span style={valueStyle}>
                {data?.created_at && moment(data.created_at).isValid()
                  ? convertDateWithTime(data.created_at, 'DD-MM-YYYY HH:mm:ss')
                  : '-'}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Last Updated By</span>
              <span style={valueStyle}>
                {!data?.updated_by
                  ? '-'
                  : firstLetterUpperCase(data?.updated_by)}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Last Updated At</span>
              <span style={valueStyle}>
                {data?.updated_at && moment(data.updated_at).isValid()
                  ? convertDateWithTime(data.updated_at, 'DD-MM-YYYY HH:mm:ss')
                  : '-'}
              </span>
            </div>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default DetailTransferRackPage
